/**
 * Téléphonie – sortes d'objets auxquels un appel est affecté (RESSOURCES_LIEES_APPEL) : clé i18n de leur nom
 * (service.telephonie.affectation.ressources.<clé>), icône et fiche (route du nœud du catalogue + identifiant).
 * Partagé par le menu « Affecter » du softphone et la fiche d'un appel (rattachements).
 */
import { noeud, type RessourceLieeAppel } from '@agora/shared';
import type { IconName } from '../../design';

/** Clé i18n de la sorte d'objet (service.telephonie.affectation.ressources.<clé>). */
export type CleSorteObjet = 'tiers' | 'contact' | 'affaire' | 'piste' | 'incident';

export const SORTES_OBJETS_APPEL: Record<RessourceLieeAppel, { cle: CleSorteObjet; icone: IconName }> = {
  tiers: { cle: 'tiers', icone: 'building' },
  contacts: { cle: 'contact', icone: 'user' },
  'commerce.vente.affaires': { cle: 'affaire', icone: 'portefeuille' },
  'commerce.prospection.pistes': { cle: 'piste', icone: 'pin' },
  'it.demandes.incidents': { cle: 'incident', icone: 'ticket' },
};

/** Fiche d'un objet affecté à un appel (/referentiels/tiers/…, /commerce/vente/affaires/…). */
export const routeObjetAppel = (ressource: RessourceLieeAppel, objetId: string): string | undefined => {
  const route = noeud(ressource)?.route;
  return route ? `${route}/${encodeURIComponent(objetId)}` : undefined;
};
